import language from '@/util/language';

export default {
  install(Vue, options) {
    Vue.prototype.$languageChoose = function(opts) {
      return opts[language] || '-';
    };
  }
};



// WEBPACK FOOTER //
// ./src/libs/language/index.js